# VA Affiliate form generation

isiVaWidget =
  # Currently only the most basic configuration options are available, more may be added in the future
  #  * aff: Affiliate Code
  config:
    aff: 'invalid'
    consent: false

  init: ->
    console.log 'Initializing ISI VA Widget.'

    if not window? or not window.isiVaSettings
      console.log 'Improperly configured VA widget. Please contact customer support.'
      return

    # Should be using object spread?
    if window.isiVaSettings.aff?
      this.config.aff = window.isiVaSettings.aff

    # Ensure valid affiliate key has been established
    if this.config.aff is '' or this.config.aff is 'invalid'
      console.log 'Invalid affiliate key.'
      return

    if this.config.aff is 'ISTU' or window.isiVaSettings.includeConsent?
      this.config.consent = true;
      console.log 'Enabled consent input.'

    this.drawForm();
    console.log 'Initialization complete.'

  buildCountryDropdown: (fieldId, fieldName) ->
    dropdown = document.createElement 'select'
    dropdown.setAttribute 'id', fieldId
    dropdown.setAttribute 'name', fieldName
    dropdown.setAttribute 'aria-required', true
    dropdown.setAttribute 'class', 'form-control form-control-sm'
    dropdown.appendChild this.countryOption country for country in this.countries
    return dropdown

  countryOption: (country) ->
    val = country.val
    name = country.name
    option = document.createElement 'option'
    option.setAttribute 'value', val
    option.appendChild document.createTextNode name
    return option

  asFormRow: ( leftElement, rightElement ) ->
    # Left Column - Name/Student/HomeCountry/Start Date
    leftColumn = document.createElement 'div'
    leftColumn.setAttribute 'class', 'col-sm'
    leftColumn.appendChild leftElement

    # Right Column - Email/Birthdate/Citizenship/End Date
    rightColumn = document.createElement 'div'
    rightColumn.setAttribute 'class', 'col-sm'
    rightColumn.appendChild rightElement

    colRow = document.createElement 'div'
    colRow.setAttribute 'class', 'form-row'
    colRow.appendChild leftColumn
    colRow.appendChild rightColumn
    return colRow

  addConsentText: (labelElement) ->
    if this.config.aff == 'ISTU'
      privacyLink = document.createElement 'a'
      privacyLink.setAttribute 'href', '/privacy-policy/'
      privacyLink.setAttribute 'target', '_blank'
      privacyLink.appendChild document.createTextNode 'Privacy Statement'
      termsLink = document.createElement 'a'
      termsLink.setAttribute 'href', '/terms/'
      termsLink.setAttribute 'target', '_blank'
      termsLink.appendChild document.createTextNode 'Terms of Use'
      labelElement.appendChild document.createTextNode ' I consent to the storage of my personal data so that InternationalStudent.com and MPOWER Financing can deliver relevant newsletters and emails to me. I agree to the '
      labelElement.appendChild termsLink
      labelElement.appendChild document.createTextNode ' and '
      labelElement.appendChild privacyLink
      labelElement.appendChild document.createTextNode ', which detail my rights to control my personal data under US law, as this is a US-based website, but also consistent with the principles of the EU’s GDPR.'
      return
    labelElement.appendChild document.createTextNode ' I consent to the storage of my personal data so that this site can deliver relevant newsletters and emails to me. I agree to the Terms of Use and Privacy Statement, which detail my rights to control my personal data under US law, as this is a US-based website, but also consistent with the principles of the EU’s GDPR.'

  createFormLabel: (labelText, fieldName) ->
    label = document.createElement 'label'
    label.setAttribute 'class', 'control-label'
    label.setAttribute 'for', fieldName
    label.appendChild document.createTextNode labelText
    return label

  drawForm: ->
    vaWidgetDiv = document.getElementById'isi-va-widget'
    if not vaWidgetDiv
      console.log 'Improperly configured VA widget -- please create the #isi-va-widget div.'
      return

    vaForm = document.createElement 'form'
    vaForm.action = ('https://www.internationalstudentinsurance.com/virtual-agent/?aff='+this.config.aff)
    vaForm.method = 'post'
    vaForm.target = '_blank'
    vaForm.setAttribute('class','card card-body mb-lg-3 p-md-4 p-xl-5 bg-primary bg-vignette shadow-sm text-light')

    vaHeader = document.createElement 'h2'
    vaHeader.setAttribute('class',"display-1 font-roboto card-title text-warning")
    vaHeader.appendChild document.createTextNode 'Find your plan'
    vaForm.appendChild vaHeader

    # Name / Email Row
    nameGroup = document.createElement 'div'
    nameGroup.setAttribute 'class', 'form-group field-virtualagentform-name required'
    nameGroup.appendChild this.createFormLabel 'Full Name *', 'virtualagentform-name'
    nameField = document.createElement 'input'
    nameField.setAttribute 'id', 'virtualagentform-name'
    nameField.setAttribute 'name', 'VirtualAgentForm[name]'
    nameField.setAttribute 'class', 'form-control form-control-sm'
    nameField.required = true
    nameGroup.appendChild nameField

    emailGroup = document.createElement 'div'
    emailGroup.setAttribute 'class', 'form-group field-virtualagentform-email required'
    emailGroup.appendChild this.createFormLabel 'Email *', 'virtualagentform-email'
    emailField = document.createElement'input'
    emailField.setAttribute 'id', 'virtualagentform-email'
    emailField.setAttribute 'type', 'email'
    emailField.setAttribute 'name', 'VirtualAgentForm[email]'
    emailField.setAttribute 'class', 'form-control form-control-sm'
    emailField.required = true
    emailGroup.appendChild emailField
    vaForm.appendChild this.asFormRow nameGroup, emailGroup

    # Destination Field
    destinationGroup = document.createElement 'div'
    destinationGroup.setAttribute 'class', 'form-group field-virtualagentform-destination required'
    destinationGroup.appendChild this.createFormLabel 'Primary Destination *', 'virtualagentform-destination'
    destinationDropdown = this.buildCountryDropdown 'virtualagentform-destination', 'VirtualAgentForm[destination]'
    destinationDropdown.required = true;
    destinationGroup.appendChild destinationDropdown
    vaForm.appendChild destinationGroup

    # Is Student / DOB Row
    studentGroup = document.createElement 'div'
    studentGroup.setAttribute 'class', 'form-group field-virtualagentform-isstudent'
    studentGroup.appendChild this.createFormLabel 'Student'
    studentField = document.createElement 'select'
    studentField.setAttribute 'id', 'virtualagentform-isstudent'
    studentField.setAttribute 'name', 'VirtualAgentForm[isStudent]'
    studentField.setAttribute 'title', 'Are you a student?'
    studentField.setAttribute 'class', 'form-control form-control-sm'
    notIsStudent = document.createElement 'option'
    notIsStudent.setAttribute 'value', '0'
    notIsStudent.appendChild document.createTextNode 'No'
    isStudent = document.createElement 'option'
    isStudent.setAttribute 'value', '1'
    isStudent.appendChild document.createTextNode 'Yes'
    studentField.appendChild isStudent
    studentField.appendChild notIsStudent
    studentGroup.appendChild studentField

    # Date of Birth
    dobGroup = document.createElement 'div'
    dobGroup.setAttribute 'class', 'form-group field-virtualagentform-birthdate required'
    dobGroup.appendChild this.createFormLabel 'Birth Date *', 'virtualagentform-birthdate'
    dobField = document.createElement'input'
    dobField.setAttribute 'id', 'virtualagentform-birthdate'
    dobField.setAttribute 'type', 'date'
    dobField.setAttribute 'value', '2002-01-01'
    dobField.setAttribute 'name', 'VirtualAgentForm[birthDate]'
    dobField.setAttribute 'class', 'form-control form-control-sm'
    dobField.required = true
    dobGroup.appendChild dobField
    vaForm.appendChild this.asFormRow studentGroup, dobGroup
    
    # Home Country
    homeCountryGroup = document.createElement 'div'
    homeCountryGroup.setAttribute 'class', 'form-group field-virtualagentform-homecountry required'
    homeCountryGroup.appendChild this.createFormLabel 'Home Country *', 'virtualagentform-homecountry'
    homeCountryDropdown = this.buildCountryDropdown 'virtualagentform-homecountry', 'VirtualAgentForm[homeCountry]'
    homeCountryDropdown.required = true
    homeCountryGroup.appendChild homeCountryDropdown

    # Citizenship
    citizenshipGroup = document.createElement 'div'
    citizenshipGroup.setAttribute 'class', 'form-group field-virtualagentform-citizenship required'
    citizenshipGroup.appendChild this.createFormLabel 'Citizenship *', 'virtualagentform-citizenship'
    citizenshipDropdown = this.buildCountryDropdown 'virtualagentform-citizenship', 'VirtualAgentForm[citizenship]'
    citizenshipDropdown.required = true
    citizenshipGroup.appendChild citizenshipDropdown

    vaForm.appendChild this.asFormRow homeCountryGroup, citizenshipGroup

    # Dates of Coverage
    startDateGroup = document.createElement 'div'
    startDateGroup.setAttribute 'class', 'form-group field-virtualagentform-startdate required'
    startDateGroup.appendChild this.createFormLabel 'Start Date *', 'virtualagentform-startdate'
    startDateField = document.createElement'input'
    startDateField.setAttribute 'id', 'virtualagentform-startdate'
    startDateField.setAttribute 'type', 'date'
    startDateField.setAttribute 'name', 'VirtualAgentForm[startDate]'
    startDateField.setAttribute 'class', 'form-control form-control-sm'
    startDateField.setAttribute 'autocomplete', 'off'
    startDateField.required = true
    startDateGroup.appendChild startDateField

    endDateGroup = document.createElement 'div'
    endDateGroup.setAttribute 'class', 'form-group field-virtualagentform-enddate required'
    endDateGroup.appendChild this.createFormLabel 'End Date *', 'virtualagentform-enddate'
    endDateField = document.createElement'input'
    endDateField.setAttribute 'id', 'virtualagentform-enddate'
    endDateField.setAttribute 'type', 'date'
    endDateField.setAttribute 'name', 'VirtualAgentForm[endDate]'
    endDateField.setAttribute 'class', 'form-control form-control-sm'
    endDateField.setAttribute 'autocomplete', 'off'
    endDateField.required = true
    endDateGroup.appendChild endDateField
    vaForm.appendChild this.asFormRow startDateGroup, endDateGroup

    if this.config.consent is true
      console.log 'Adding consent input'
      consentGroup = document.createElement 'div'
      consentGroup.setAttribute 'class', 'form-check'
      consentLabel = document.createElement 'label'
      consentLabel.setAttribute 'class', 'form-check-label'
      consentHidden = document.createElement 'input'
      consentHidden.setAttribute 'name', 'VirtualAgentForm[consent]'
      consentHidden.setAttribute 'value', '0'
      consentHidden.setAttribute 'type', 'hidden'
      consentLabel.appendChild consentHidden
      consentCheck = document.createElement 'input'
      consentCheck.setAttribute 'id', 'virtualagentform-consent'
      consentCheck.setAttribute 'type', 'checkbox'
      consentCheck.setAttribute 'value', '1'
      consentCheck.setAttribute 'aria-invalid', 'true'
      consentCheck.setAttribute 'name', 'VirtualAgentForm[consent]'
      consentLabel.appendChild consentCheck
      this.addConsentText consentLabel
      consentGroup.appendChild consentLabel
      vaForm.appendChild consentGroup

    submitBtn = document.createElement 'button'
    submitBtn.appendChild document.createTextNode 'View Plans'
    submitBtn.setAttribute 'class' ,'btn btn-block btn-warning va-submit font-weight-bold'
    vaForm.appendChild submitBtn
    vaWidgetDiv.appendChild vaForm

  countries: [
    { val: '', name: 'Choose One:'}
    { val: 254, name: 'United States'}
    { val: 49, name: 'China'}
    { val: 43, name: 'Canada'}
    { val: 253, name: 'United Kingdom'}
    { val: 'x', name: '--------'}
    { val: 1, name: 'Afghanistan'}
    { val: 276, name: 'Aland Islands'}
    { val: 2, name: 'Albania'}
    { val: 3, name: 'Algeria'}
    { val: 4, name: 'American Samoa'}
    { val: 5, name: 'Andorra'}
    { val: 6, name: 'Angola'}
    { val: 7, name: 'Anguilla'}
    { val: 8, name: 'Antarctica'}
    { val: 9, name: 'Antigua and Barbuda'}
    { val: 10, name: 'Argentina'}
    { val: 11, name: 'Armenia'}
    { val: 12, name: 'Aruba'}
    { val: 13, name: 'Ashmore and Cartier'}
    { val: 14, name: 'Australia'}
    { val: 15, name: 'Austria'}
    { val: 16, name: 'Azerbaijan'}
    { val: 18, name: 'Bahrain'}
    { val: 19, name: 'Baker Island'}
    { val: 20, name: 'Bangladesh'}
    { val: 21, name: 'Barbados'}
    { val: 22, name: 'Bassas da India'}
    { val: 23, name: 'Belarus'}
    { val: 24, name: 'Belgium'}
    { val: 25, name: 'Belize'}
    { val: 26, name: 'Benin'}
    { val: 27, name: 'Bermuda'}
    { val: 28, name: 'Bhutan'}
    { val: 29, name: 'Bolivia'}
    { val: 30, name: 'Bosnia and Herzegovina'}
    { val: 31, name: 'Botswana'}
    { val: 32, name: 'Bouvet Island'}
    { val: 33, name: 'Brazil'}
    { val: 34, name: 'British Indian Ocean Territory'}
    { val: 35, name: 'British Virgin Islands'}
    { val: 36, name: 'Brunei Darussalam'}
    { val: 37, name: 'Bulgaria'}
    { val: 38, name: 'Burkina Faso'}
    { val: 39, name: 'Burma'}
    { val: 40, name: 'Burundi'}
    { val: 41, name: 'Cambodia'}
    { val: 42, name: 'Cameroon'}
    { val: 44, name: 'Cape Verde'}
    { val: 45, name: 'Cayman Islands'}
    { val: 46, name: 'Central African Republic'}
    { val: 47, name: 'Chad'}
    { val: 48, name: 'Chile'}
    { val: 50, name: 'Christmas Island'}
    { val: 51, name: 'Clipperton Island'}
    { val: 52, name: 'Cocos (Keeling) Islands'}
    { val: 53, name: 'Colombia'}
    { val: 54, name: 'Comoros'}
    { val: 55, name: 'Congo, Democratic Republic of the'}
    { val: 56, name: 'Congo, Republic of the'}
    { val: 57, name: 'Cook Islands'}
    { val: 58, name: 'Coral Sea Islands'}
    { val: 59, name: 'Costa Rica'}
    { val: 60, name: 'Cote d&#039;Ivoire'}
    { val: 61, name: 'Croatia'}
    { val: 62, name: 'Cuba'}
    { val: 63, name: 'Cyprus'}
    { val: 64, name: 'Czech Republic'}
    { val: 65, name: 'Denmark'}
    { val: 66, name: 'Djibouti'}
    { val: 67, name: 'Dominica'}
    { val: 68, name: 'Dominican Republic'}
    { val: 69, name: 'East Timor'}
    { val: 70, name: 'Ecuador'}
    { val: 71, name: 'Egypt'}
    { val: 72, name: 'El Salvador'}
    { val: 73, name: 'Equatorial Guinea'}
    { val: 74, name: 'Eritrea'}
    { val: 75, name: 'Estonia'}
    { val: 76, name: 'Ethiopia'}
    { val: 77, name: 'Europa Island'}
    { val: 78, name: 'Falkland Islands (Islas Malvinas)'}
    { val: 79, name: 'Faroe Islands'}
    { val: 80, name: 'Fiji'}
    { val: 81, name: 'Finland'}
    { val: 82, name: 'France'}
    { val: 83, name: 'France, Metropolitan'}
    { val: 84, name: 'French Guiana'}
    { val: 85, name: 'French Polynesia'}
    { val: 86, name: 'French Southern &amp; Antarctic Lands'}
    { val: 87, name: 'Gabon'}
    { val: 89, name: 'Gaza Strip'}
    { val: 90, name: 'Georgia'}
    { val: 91, name: 'Germany'}
    { val: 92, name: 'Ghana'}
    { val: 93, name: 'Gibraltar'}
    { val: 94, name: 'Glorioso Islands'}
    { val: 95, name: 'Greece'}
    { val: 96, name: 'Greenland'}
    { val: 97, name: 'Grenada'}
    { val: 98, name: 'Guadeloupe'}
    { val: 99, name: 'Guam'}
    { val: 100, name: 'Guatemala'}
    { val: 101, name: 'Guernsey'}
    { val: 102, name: 'Guinea'}
    { val: 103, name: 'Guinea-Bissau'}
    { val: 104, name: 'Guyana'}
    { val: 105, name: 'Haiti'}
    { val: 106, name: 'Heard Island and McDonald Islands'}
    { val: 107, name: 'Holy See (Vatican City)'}
    { val: 108, name: 'Honduras'}
    { val: 109, name: 'Hong Kong (SAR)'}
    { val: 110, name: 'Howland Island'}
    { val: 111, name: 'Hungary'}
    { val: 112, name: 'Iceland'}
    { val: 113, name: 'India'}
    { val: 114, name: 'Indonesia'}
    { val: 115, name: 'Iran'}
    { val: 116, name: 'Iraq'}
    { val: 117, name: 'Ireland'}
    { val: 118, name: 'Israel'}
    { val: 119, name: 'Italy'}
    { val: 120, name: 'Jamaica'}
    { val: 121, name: 'Jan Mayen'}
    { val: 122, name: 'Japan'}
    { val: 123, name: 'Jarvis Island'}
    { val: 124, name: 'Jersey'}
    { val: 125, name: 'Johnston Atoll'}
    { val: 126, name: 'Jordan'}
    { val: 127, name: 'Juan de Nova Island'}
    { val: 128, name: 'Kazakhstan'}
    { val: 129, name: 'Kenya'}
    { val: 130, name: 'Kingman Reef'}
    { val: 131, name: 'Kiribati'}
    { val: 132, name: 'Korea, North'}
    { val: 133, name: 'Korea, South'}
    { val: 278, name: 'Kosovo'}
    { val: 134, name: 'Kuwait'}
    { val: 135, name: 'Kyrgyzstan'}
    { val: 136, name: 'Laos'}
    { val: 137, name: 'Latvia'}
    { val: 138, name: 'Lebanon'}
    { val: 139, name: 'Lesotho'}
    { val: 140, name: 'Liberia'}
    { val: 141, name: 'Libya'}
    { val: 142, name: 'Liechtenstein'}
    { val: 143, name: 'Lithuania'}
    { val: 144, name: 'Luxembourg'}
    { val: 145, name: 'Macao'}
    { val: 146, name: 'Macedonia'}
    { val: 147, name: 'Madagascar'}
    { val: 148, name: 'Malawi'}
    { val: 149, name: 'Malaysia'}
    { val: 150, name: 'Maldives'}
    { val: 151, name: 'Mali'}
    { val: 152, name: 'Malta'}
    { val: 153, name: 'Man, Isle of'}
    { val: 154, name: 'Marshall Islands'}
    { val: 155, name: 'Martinique'}
    { val: 156, name: 'Mauritania'}
    { val: 157, name: 'Mauritius'}
    { val: 158, name: 'Mayotte'}
    { val: 159, name: 'Mexico'}
    { val: 160, name: 'Micronesia, Federated States of'}
    { val: 161, name: 'Midway Islands'}
    { val: 162, name: 'Miscellaneous (French)'}
    { val: 163, name: 'Moldova'}
    { val: 164, name: 'Monaco'}
    { val: 165, name: 'Mongolia'}
    { val: 166, name: 'Montenegro'}
    { val: 167, name: 'Montserrat'}
    { val: 168, name: 'Morocco'}
    { val: 169, name: 'Mozambique'}
    { val: 170, name: 'Myanmar'}
    { val: 171, name: 'Namibia'}
    { val: 172, name: 'Nauru'}
    { val: 173, name: 'Navassa Island'}
    { val: 174, name: 'Nepal'}
    { val: 175, name: 'Netherlands'}
    { val: 176, name: 'Netherlands Antilles'}
    { val: 177, name: 'New Caledonia'}
    { val: 178, name: 'New Zealand'}
    { val: 179, name: 'Nicaragua'}
    { val: 180, name: 'Niger'}
    { val: 181, name: 'Nigeria'}
    { val: 182, name: 'Niue'}
    { val: 183, name: 'Norfolk Island'}
    { val: 184, name: 'Northern Mariana Islands'}
    { val: 185, name: 'Norway'}
    { val: 186, name: 'Oman'}
    { val: 187, name: 'Pakistan'}
    { val: 188, name: 'Palau'}
    { val: 275, name: 'Palestinian Territory, Occupied'}
    { val: 189, name: 'Palmyra Atoll'}
    { val: 190, name: 'Panama'}
    { val: 191, name: 'Papua New Guinea'}
    { val: 192, name: 'Paracel Islands'}
    { val: 193, name: 'Paraguay'}
    { val: 194, name: 'Peru'}
    { val: 195, name: 'Philippines'}
    { val: 196, name: 'Pitcairn Islands'}
    { val: 197, name: 'Poland'}
    { val: 198, name: 'Portugal'}
    { val: 199, name: 'Puerto Rico'}
    { val: 200, name: 'Qatar'}
    { val: 201, name: 'Reunion'}
    { val: 202, name: 'Romania'}
    { val: 203, name: 'Russia'}
    { val: 204, name: 'Rwanda'}
    { val: 205, name: 'Saint Helena'}
    { val: 206, name: 'Saint Kitts and Nevis'}
    { val: 207, name: 'Saint Lucia'}
    { val: 208, name: 'Saint Pierre and Miquelon'}
    { val: 209, name: 'Saint Vincent and the Grenadines'}
    { val: 210, name: 'Samoa'}
    { val: 211, name: 'San Marino'}
    { val: 212, name: 'Sao Tome and Principe'}
    { val: 213, name: 'Saudi Arabia'}
    { val: 214, name: 'Senegal'}
    { val: 215, name: 'Serbia'}
    { val: 216, name: 'Serbia and Montenegro'}
    { val: 217, name: 'Seychelles'}
    { val: 218, name: 'Sierra Leone'}
    { val: 219, name: 'Singapore'}
    { val: 220, name: 'Slovakia'}
    { val: 221, name: 'Slovenia'}
    { val: 222, name: 'Solomon Islands'}
    { val: 223, name: 'Somalia'}
    { val: 224, name: 'South Africa'}
    { val: 225, name: 'South Sandwich Islands'}
    { val: 277, name: 'South Sudan'}
    { val: 226, name: 'Spain'}
    { val: 227, name: 'Spratly Islands'}
    { val: 228, name: 'Sri Lanka'}
    { val: 229, name: 'Sudan'}
    { val: 230, name: 'Suriname'}
    { val: 231, name: 'Svalbard'}
    { val: 232, name: 'Swaziland'}
    { val: 233, name: 'Sweden'}
    { val: 234, name: 'Switzerland'}
    { val: 235, name: 'Syria'}
    { val: 236, name: 'Taiwan'}
    { val: 237, name: 'Tajikistan'}
    { val: 238, name: 'Tanzania'}
    { val: 239, name: 'Thailand'}
    { val: 17, name: 'The Bahamas'}
    { val: 88, name: 'The Gambia'}
    { val: 240, name: 'Togo'}
    { val: 241, name: 'Tokelau'}
    { val: 242, name: 'Tonga'}
    { val: 243, name: 'Trinidad and Tobago'}
    { val: 244, name: 'Tromelin Island'}
    { val: 245, name: 'Tunisia'}
    { val: 246, name: 'Turkey'}
    { val: 247, name: 'Turkmenistan'}
    { val: 248, name: 'Turks and Caicos Islands'}
    { val: 249, name: 'Tuvalu'}
    { val: 250, name: 'Uganda'}
    { val: 251, name: 'Ukraine'}
    { val: 252, name: 'United Arab Emirates'}
    { val: 255, name: 'United States Minor Outlying Islands'}
    { val: 256, name: 'Uruguay'}
    { val: 257, name: 'Uzbekistan'}
    { val: 258, name: 'Vanuatu'}
    { val: 259, name: 'Venezuela'}
    { val: 260, name: 'Vietnam'}
    { val: 261, name: 'Virgin Islands'}
    { val: 262, name: 'Virgin Islands (UK)'}
    { val: 263, name: 'Virgin Islands (US)'}
    { val: 264, name: 'Wake Island'}
    { val: 265, name: 'Wallis and Futuna'}
    { val: 266, name: 'West Bank'}
    { val: 267, name: 'Western Sahara'}
    { val: 268, name: 'Western Samoa'}
    { val: 269, name: 'World'}
    { val: 270, name: 'Yemen'}
    { val: 271, name: 'Yugoslavia'}
    { val: 272, name: 'Zaire'}
  ]

isiVaWidget.init()